import moment from 'moment';

export const returnFileSize = (number) => `${(number / 1024).toFixed(1)} KB`;

export const formatedFileName = (name) => {
  if (!name) return name;
  if (name.length > 19) {
    return `${name.slice(0, 9)}...${name.slice(-7)}`;
  }
  return name;
};

export const isTokenExpired = (exp) => {
  if (!exp) return false;

  const expired = moment(exp * 1000);
  const current = moment(new Date());

  if (expired.diff(current) < 0) {
    return true;
  }

  return false;
};

export const uuid = () => ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) => (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16));
